import { connect } from 'react-redux';
import ActivityHistory from '../components/ActivityHistory';

import { startRequest } from '../redux/history/actions';
import { createStructuredSelector } from 'reselect';
import { flow, property } from 'lodash';
import { bindActionCreators } from 'redux';

export default connect(
  createStructuredSelector({
    history: createStructuredSelector({
      data: flow(property('profile.history'), (history) => history.get('data')),
      loading: flow(property('profile.history'), (history) => history.get('loading')),
      error: flow(property('profile.history'), (history) => history.get('error')),
    }),
  }),
  (dispatch) =>
    bindActionCreators(
      {
        getHistory: startRequest,
      },
      dispatch,
    ),
)(ActivityHistory);
